export const showCallAttributesToRetrieve = [
  '_geoloc',
  'publicBeacon.isPublicCall',
  'publicBeacon.profileId',
  'publicBeacon.profileType',
  'publicBeacon.profileData.name',
  'publicBeacon.profileData.publicImageUrl',
  'publicBeacon.profileData.numReviews',
  'publicBeacon.profileData.score',
  'publicBeacon.profileData.badge',
  'publicBeacon.profileData.spotifyMonthlyActiveListeners',
  'publicBeacon.fuzzyLatLng',
  'publicBeacon.city',
  'publicBeacon.region',
  'publicBeacon.startDate',
  'publicBeacon.endDate',
  'publicBeacon.isFeatured',
];
